import React, {Component} from "react";
import PropTypes from "prop-types";
import {withStyles} from "@material-ui/core/styles";

import CircularProgress from '@material-ui/core/CircularProgress';
import LogoArea from "./logo-area";
import AnswerInput from "./answer-input";
import GuessedRiddleNavigationContainer from "./guessed-riddle-navigation-container";
import {playCorrectAudio, playWrongAudio, vibrateWrong} from '../../helpers/sounds';
import {getTranslation} from "../../helpers/get-translation";
// import KeyboardAnswer from "./game-input/-keyboard-answer";

const styles = theme => ({
	root: {
		display: "flex",
		flexDirection: "column",
		height: "100%"
	},
	answeringRoot:{
	},
	gameWrapper: {
		height: "100%"
	},
	logoArea: {
		marginTop: "0",
	},
	answer: {
		fontSize: "30px",
		textAlign: "center",
		textTransform: "uppercase",
	},
	hintsClue:{
		margin: "20px 15px 10px",
		textAlign: "center",
		fontSize: "20px",
		"& img": {
			height: "35px",
			width: "auto",
			cursor: "pointer",
		}
	},
	guessedRiddleContent:{
		overflowX: 'auto',
		height: '100%'
	},
	loading:{
		display: "flex",
		justifyContent: "center",
		marginTop: "20px",
	}
});


export const CORRECT_ANSWER = "CORRECT_ANSWER";
export const WRONG_ANSWER = "WRONG_ANSWER";
export const ALMOST_GUESSED_ANSWER = "ALMOST_GUESSED_ANSWER";

class GameScreen extends Component {
	state = {
		userAnswer: '',
		isChecking: false,
		lp: -1,
		isShaking: false,
		isAnswerButtonThrottled: false
	};

	timeoutList = [];

	componentWillUnmount(){
		this.timeoutList.forEach((id) => {
			clearTimeout(id);
		})
	}


	static getDerivedStateFromProps(props, state) {
		const activeLp = props.activeLogo.lp;
		//Jeśli użytkownik zmienni riddle nawigacją
		if(activeLp !== state.lp){
			return {
				lp: activeLp,
				userAnswer: ''
			};
		}
		return null;
	}

//Jeśli user zmieni riddle na odgagniety, to wyscrolluj content do góry
	componentDidUpdate(prevProps) {
		const prevActiveLp = prevProps.activeLogo.lp;
		const currentActiveLp = this.props.activeLogo.lp;

		if(prevActiveLp !== currentActiveLp) {
			this.resetScrollPosition()
		}
	}

	resetScrollPosition = () => {
		const container = document.querySelector('#guessed-riddle-content');

		if(container){
			container.scrollTop = 0;
		}
	}

//Kazdy timeout dodajemy do listy, żeby potem wyłączyć przy unmount
	stopShaking = () => {
		this.timeoutList.push(setTimeout(() => {
			this.setState({ isShaking: false })
		}, 1000))
	};

	wrongAnswerAction = () => {
		if(this.props.isSound){
			playWrongAudio()
		}

		if(this.props.isVibrate){
			vibrateWrong()
		}

		this.setState({ isShaking: true }, this.stopShaking);
	};

	checkRiddleCallback = (answerState) =>{
		this.setState({isChecking: false});

		if(answerState === CORRECT_ANSWER && this.props.isSound){
			playCorrectAudio();
		} else if(answerState === ALMOST_GUESSED_ANSWER){
			this.wrongAnswerAction();
		} else if(answerState === WRONG_ANSWER){
			this.wrongAnswerAction();
			this.props.addToast('toast_answer_incorrect')
		}
	};

	handleChange = (e) => {
		this.setState({userAnswer: e.target.value});
	};

	handleSubmit = (e) => {
		e.preventDefault();
		if(this.state.isChecking || this.state.isAnswerButtonThrottled){
			return
		}
		this.throttleButton();
		this.setState({isChecking: true});
		// console.log('isChecking true');
		this.props.checkRiddleAnswer(this.props.activeLogo, this.state.userAnswer, this.checkRiddleCallback);
	};

	throttleButton = () => {
		this.setState({ isAnswerButtonThrottled: true}, () => {
			const timeout = setTimeout(() => {
				this.setState({ isAnswerButtonThrottled: false})
			}, 1000);

			this.timeoutList.push(timeout)
		})
	};

	render() {
		const { classes,
			activeLogo,
			imgServerUrl,
			imgSolvedServerUrl,
			addModalWindow,
			isModalOpen } = this.props;
		const { userAnswer, isChecking, isShaking } = this.state;
		const { handleChange, handleSubmit } = this;
		// console.log(this.props);

		const isLoading = !activeLogo.answer;

		if(activeLogo.isSolved){
			return (
				<div
					className={classes.root}
				>
					<div className={classes.guessedRiddleContent} id={'guessed-riddle-content'}>
						<div className={classes.logoArea}>
							<LogoArea activeLogo={activeLogo} imgServerUrl={imgServerUrl} imgSolvedServerUrl={imgSolvedServerUrl}/>
						</div>
						{!isLoading && <div className={classes.answer}>{activeLogo.answer[0]}</div>}
						{!isLoading &&
						<div className={classes.hintsClue}>
							<a target="_blank" href={activeLogo.wikipediaUrl} rel="noopener noreferrer">
								<img src={getTranslation("image_hint_wikipedia_logo")}/>
							</a>
							<span>
								{activeLogo.hintClue1}{activeLogo.hintClue2}
							</span>
						</div>
						}

						{isLoading &&
						<div className={classes.loading}>
							<CircularProgress />
						</div>
						}
					</div>
					<GuessedRiddleNavigationContainer
						isLoading={isLoading}
						stringIndex={activeLogo.lp}
						imgServerUrl={imgServerUrl}
						points={activeLogo.points}
						resetScrollPosition={this.resetScrollPosition}/>

				</div>
			);
		} else {
			return (
				<div
					className={[classes.root, classes.answeringRoot].join(" ")}
				>
					<div className={classes.logoArea}>
						<LogoArea activeLogo={activeLogo} imgServerUrl={imgServerUrl} imgSolvedServerUrl={imgSolvedServerUrl} isShaking={isShaking}/>
					</div>
					<div>
						<form onSubmit={handleSubmit} >
							<AnswerInput
								isModalOpen={isModalOpen}
								userAnswer={userAnswer}
								onChange={handleChange}
								handleSubmit={handleSubmit}
								isChecking={isChecking}
								addModalWindow={addModalWindow}/>
						</form>
					</div>
				</div>
			)
		}
	}
}

GameScreen.propTypes = {
	gameType: PropTypes.string.isRequired,
	isCheckingAnswer: PropTypes.bool.isRequired,
	isModalOpen: PropTypes.bool.isRequired,
	isSound: PropTypes.bool.isRequired,
	isVibrate: PropTypes.bool.isRequired,

	activeLogo: PropTypes.object.isRequired,

	classes: PropTypes.shape({
		root: PropTypes.string.isRequired,
		gameWrapper: PropTypes.string.isRequired,
		logoArea: PropTypes.string.isRequired,
		answer: PropTypes.string.isRequired,
	}).isRequired,

	push: PropTypes.func.isRequired,
	checkRiddleAnswer: PropTypes.func.isRequired,
	addToast: PropTypes.func.isRequired,
	addModalWindow: PropTypes.func.isRequired,
};

export default withStyles(styles)(GameScreen);
